import React, { forwardRef, useCallback, useMemo } from "react";
import { Platform, TextInput as RNTextInput, View, } from "react-native";
import { style as textInputStyle } from "./TextInput.style";
const TextInput = forwardRef(({ children, maxLength, value, style: customStyle, autoCapitalize = "sentences", testID = "text-input", placeholder, onChange, onComplete, ...props }, ref) => {
    const style = useMemo(() => textInputStyle(), []);
    const handleOnChangeText = useCallback((value) => {
        onChange(value);
        if (value?.length === maxLength) {
            onComplete?.(value);
        }
    }, [maxLength, onChange, onComplete]);
    return (React.createElement(View, { style: [style.container, customStyle?.container] },
        React.createElement(RNTextInput, { ...props, ref: ref, accessibilityValue: { text: value }, autoCapitalize: autoCapitalize, maxLength: maxLength, placeholder: placeholder, placeholderTextColor: style.placeholderTextColor, testID: testID, value: value ? value : "", style: [
                style.input,
                // @ts-ignore
                placeholder && Platform.OS === "ios" && { lineHeight: undefined, paddingBottom: 0 },
                customStyle?.input,
            ], accessible: true, onChangeText: handleOnChangeText }),
        children));
});
TextInput.displayName = "TextInput";
export { TextInput };
